<template>
  <div class="page">
    <navigation :customClickEvent="true" @click="detention">拿额度，仅需两步</navigation>
    <section class="content">
      <section class="title">
        <img
          src="./images/img_01.png"
          srcset="./images/img_01@2x.png 2x, ./images/img_01@3x.png 3x"
        />身份认证
      </section>
      <section class="tips">
        仅用于身份审核，拍摄时请确保身份证边框完整、字迹清晰
      </section>
      <u class="help" @click="navigateTo('/authentication/id/guide')">身份证识别遇到问题</u>
      <section class="picture">
        <div class="item">
          <img :src="frontImg" />
          <input
            ref="frontInput"
            type="file"
            accept="image/*"
            class="frontInput"
            @change="changeHandler($event, 'CARD_FRONT_PHOTO')"
          />
          <span class="text" v-show="!frontCoverVisible">
            请拍摄人像面
          </span>
        </div>
        <div class="item">
          <img :src="backImg" />
          <input
            ref="backInput"
            type="file"
            accept="image/*"
            class="backInput"
            @change="changeHandler($event, 'CARD_BACK_PHOTO')"
          />
          <span class="text" v-show="!backCoverVisible">
            请拍摄国徽面
          </span>
        </div>
      </section>
      <section class="id-info">
        <p class="info-tips">*请确认您的信息，若有误请点击修改</p>
        <form class="form">
          <div class="form-item underline-un-focus">
            <nd-input
              name="name"
              v-model="form.name"
              maxLength="10"
              label="真实姓名"
              placeholder="请填写真实姓名"
              text-align="right"
              @input="nameInput"
            >
            </nd-input>
          </div>
          <div class="form-item underline-un-focus">
            <nd-input
              name="idcardNumber"
              v-model="form.idcardNumber"
              maxLength="18"
              label="身份证号"
              placeholder="请填写身份证号"
              text-align="right"
              @input="idcardInput"
            >
            </nd-input>
          </div>
          <div class="form-item underline-un-focus">
            <nd-choose
              name="education"
              v-model="form.education"
              :data="dictionary.educationTypes"
              :valueKey="['key', 'description']"
              label="最高学历"
            >
            </nd-choose>
          </div>
          <div class="form-item underline-un-focus">
            <nd-choose
              name="marital"
              v-model="form.marital"
              :data="dictionary.maritalStatus"
              :valueKey="['key', 'description']"
              label="婚姻状况"
            >
            </nd-choose>
          </div>
          <div class="form-item underline-un-focus">
            <nd-address
              name="addressSelect"
              v-model="form.addressSelect"
              :columns="3"
              :mutilple="true"
              inputStyle="width: 70%;margin-left: 30%"
              label="现居住地"
            >
            </nd-address>
          </div>
          <div class="form-item underline-un-focus textarea">
            <nd-input
              type="textarea"
              name="address"
              v-model="form.address"
              text-align="left"
              placeholder="请输入五位以上的详细地址：如小区、楼栋号、单元等"
              maxLength="40"
              @input="addressInput"
            >
            </nd-input>
          </div>
        </form>
      </section>
      <!-- <section class="id-card-info">
                <div class="tip">
                    *请确认您的信息，若有误请点击修改
                </div>
                <div class="id-card-info-item">
                    <span class="label"
                        >真实姓名</span
                    ><nd-input v-model="name" @input="nameInput"></nd-input>
                </div>
                <div class="line"></div>
                <div class="id-card-info-item">
                    <span class="label">身份证号</span
                    ><nd-input v-model="idcardNumber" @input="idcardInput" maxLength="18"></nd-input>
                </div>
            </section> -->
      <section class="error-info" v-show="ocrErrorVisible || errorInfoVisible">
        {{ ocrErrorInfo || errorInfo }}
      </section>
    </section>

    <div class="bottom-protocol">
      <span>点击「下一步」按钮表示您已阅读并同意</span>
      <span class="active" @click="checkProtocols">《用户信息授权协议》</span>
    </div>
    <nd-button
      class="next-step"
      :disabled="disabled"
      v-stat="{ id: 10074, args: { position: 'page_auth_identity' } }"
      @click="next"
    >下一步</nd-button>

    <canvas id="canvas" v-show="false" width="1440" height="1080"></canvas>

    <nd-dialog
      v-model="detentionVisible"
      class="detention-dialog"
      :footer="false"
    >
      <div class="detention-content">
        <div class="header">
          <p>填写简单的信息，最高即可获得</p>
          <p>5万额度！真的要放弃吗？</p>
        </div>
        <ul class="body">
          <li
            v-for="(item, index) in giveUpReason"
            :key="index"
            @click="giveUp(index + 1)"
          >
            {{ item }}
          </li>
        </ul>
        <button class="footer" @click="neverGiveup">
          继续完成实名认证
        </button>
      </div>
    </nd-dialog>

    <!-- 活动弹窗 -->
    <nd-dialog
      v-model="activityVisible"
      :footer="false"
      closeBtn
      class="activity-dialog"
    >
      <div class="activity-content">
        <template v-if="currentActivity.couponDetailType === 'A'">
          <div class="slogan">
            <img src="./images/img_20yuan@2x.png" alt="" />
          </div>

          <p class="text">
            活动期间，<em>通过率高达平时2倍</em>，填写简单资料，可借额度高达<em>5万元</em>!
          </p>

          <div class="description">
            <div class="desc-image"></div>

            <p>
              授信未通过,即刻赔付现金红包！
              <em>更有幸运儿可获100元</em>
            </p>
          </div>

          <nd-button class="continue-btn" @click="activityContinue">继续完成实名认证</nd-button>

          <div class="giveup-btn" @click="activityGiveUp">
            {{
              currentActivity.activeType === "PAY_IF_REFUSE_NEW"
                ? "给钱也不要"
                : "放弃奖励"
            }}
          </div>
        </template>
        <template v-else>
          <div class="slogan">
            <img src="./images/img_100yuan@2x.png" alt="" />
          </div>

          <p class="text">
            活动期间，<em>通过率高达平时2倍</em>，填写简单资料，可借额度高达<em>5万元</em>!
          </p>

          <div class="description">
            <div class="desc-image"></div>

            <p>
              授信未通过,即刻赔付现金红包！
              <em>最高赔100元</em>
            </p>
          </div>

          <nd-button class="continue-btn" @click="activityContinue">继续完成实名认证</nd-button>

          <div class="giveup-btn" @click="activityGiveUp">
            {{
              currentActivity.activeType === "PAY_IF_REFUSE_NEW"
                ? "给钱也不要"
                : "放弃奖励"
            }}
          </div>
        </template>
      </div>
    </nd-dialog>

    <!-- 活动弹窗 -->
    <nd-dialog
      v-model="activityTempleVisible"
      :footer="false"
      closeBtn
      :class="[
        'activity-dialog',
        {
          'new-person-activity': currentActivity.activeType === 'NEW_PERSON_V2',
        },
      ]"
    >
      <div
        class="activity-template-content"
        :style="{ 'background-image': `url(${currentActivity.icon})` }"
      >
        <div class="button-group">
          <nd-button class="continue-btn" @click="activityContinue">{{
            popConfirmTitle
          }}</nd-button>
          <div class="giveup-btn" @click="activityGiveUp">
            {{ popCancelTitle }}
          </div>
        </div>
      </div>
    </nd-dialog>

    <div class="drawer-container" :class="{show}" v-if="show && diversionData && diversionData.logo">
      <i class="mask"></i>
      <div class="drawer-content">
        <h3></h3>
        <div class="detail">
          <div class="title">
            <img :src="diversionData.logo" alt="" /> <b>{{ diversionData.productName }}</b>
            <span>{{ diversionData.productDesc }}</span>
          </div>
          <p class="exp">您已获得预授信额度</p>
          <div class="quota">
            <small>￥</small>
            <span>{{ diversionData.availableAmount | amount }}</span>
          </div>
          <div class="progress"></div>
          <p class="max">最大 ¥{{ diversionData.creditLimit | amount }}</p>
        </div>
        <div class="button" @click="riverMiddle"><!-- 立即提现 --></div>
        <div class="count-down" v-if="time>0">
          距通道关闭 <van-count-down :time="time" @finish="time=0"/>
        </div>
      </div>
      <div class="next-btn" @click="toResult">继续申请</div>
    </div>
  </div>
</template>

<script>
import pic01 from './images/img_zheng@2x.png'
import pic02 from './images/img_fan@2x.png'
import ImageCompressor from 'image-compressor.js'
import { mapActions, mapState } from 'vuex'
import { getKey, isEmojiCharacter, setKey } from '../../assets/utils'
import { CountDown } from 'vant'
let timer = null

function debounce (fn, wait) {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
  timer = setTimeout(function () {
    fn()
  }, wait)
}

export default {
  name: 'authentication-id',

  customReadyNotify: true,

  data () {
    return {
      time: 15 * 60e3,
      show: false,
      applyNo: null,
      diversionData: {},
      form: {
        orderNo: null,
        name: '',
        idcardNumber: '',
        education: '',
        marital: '',
        addressSelect: '',
        address: ''
      },
      rules: {
        address: [
          {
            require: true,
            message: '详细地址不能为空',
            trigger: 'blur'
          },
          {
            handler: (input) =>
              input.length > 5 &&
              /[\u4e00-\u9fa5][\u4e00-\u9fa5a-zA-Z0-9()（）·]+$/.test(input) &&
              !isEmojiCharacter(input),
            message: '请输入正确的居住地址',
            trigger: 'blur'
          }
        ]
      },
      frontImg: pic01,
      frontFile: '',
      backImg: pic02,
      backFile: '',
      infoVisible: false, // 身份信息可见性
      ocrErrorVisible: false,
      ocrErrorInfo: '',
      errorInfoVisible: false, // 错误信息可见性
      errorInfo: '',
      frontCoverVisible: false,
      backCoverVisible: false,
      detentionVisible: false,
      activityVisible: false,
      activityTempleVisible: false,
      pfrom: this.$route.query.pfrom,
      currentActivity: {},
      process: '',
      giveUpReason: [
        '放弃免费额度',
        '操作不便，不想继续',
        '手边资料不全，无法完成'
      ],
      name: null,
      idcardNumber: null,
      popupList: []
    }
  },

  computed: {
    ...mapState({
      dictionary: (state) => state.dictionary || {},
      caseList: (state) => state.caseList,
      [CountDown.name]: CountDown
    }),

    disabled () {
      return (
        !this.checkName() ||
        !this.checkIDCard() ||
        !this.form.education ||
        !this.form.marital ||
        !this.form.addressSelect ||
        !this.checkAddress() ||
        !this.form.orderNo
      )
    },
    popConfirmTitle () {
      return this.currentActivity.activeType === 'NEW_PERSON_V2'
        ? '去拿188元'
        : '继续完成实名认证'
    },
    popCancelTitle () {
      return this.currentActivity.activeType === 'NEW_PERSON_V2'
        ? '放弃好运'
        : this.currentActivity.activeType === 'NEW_PERSON'
          ? '放弃奖励'
          : '放弃免息返现'
    }
  },

  watch: {
    // 是否照了正面
    frontFile (value) {
      if (value && this.backFile) {
        this.IDOCR()
      }
    },
    // 是否照了背面
    backFile (value) {
      if (value && this.frontFile) {
        this.IDOCR()
      }
    },

    detentionVisible (value) {
      this.$report({
        id: 10077,
        args: {
          visible: value ? 1 : 0,
          position: 'page_auth_identity'
        }
      })
    },

    activityVisible (value) {
      this.$report({
        id: 10121,
        args: {
          position: 'page_auth_identity',
          visible: value ? 1 : 0,
          status: this.currentActivity.activeType
        }
      })
    },

    activityTempleVisible (value) {
      this.$report({
        id: 10121,
        args: {
          position: 'page_auth_identity',
          visible: value ? 1 : 0,
          status: this.currentActivity.activeType
        }
      })
    }
  },

  async created () { 
    this.applyNo = getKey('isRefused')
    this.diversionData = JSON.parse(sessionStorage.getItem('refusedPr') || '{}')
    if (this.applyNo && this.diversionData && this.diversionData.logo) {
      this.showAd()
    }

    await Promise.all([
      this.fetchDictionaryX(),
      this.getCaseListX({ loanPlatform: 'TMD', step: 'OCR' })
    ])
    this.$bus.$emit('ready')
    this.ocrAddTag()
  },

  methods: {
   
    showAd () {
      this.show = true
      this.$sensors.track(
        'Diversion_Exposure', 
        { 
          product_type: 'diversion', 
          page_status: 'pre-credit',
          element_positon: 'product_pop',
          product_code: this.diversionData.configId
      })
    },
    ...mapActions('user', ['getUserInfoX', 'ocrAddTag']),
    ...mapActions('authentication', [
      'TXOCRX',
      'preCreditApplyX',
      'verifyOcrX',
      'preCreditPopup',
      'uploadOSS',
      'fillProcessX'
    ]),
    // 校验用户是否是需要去补充资料银行卡的人群
    async fillProcess () {
      const { success, data } = await this.fillProcessX()
      if (success) {
        this.process = data.process
      }
    },
    riverMiddle () {
      this.$sensors.track(
        'Diversion_Click', 
        { 
          product_type: 'diversion', 
          page_status: 'pre-credit',
          element_positon: 'product_pop',
          product_code: this.diversionData.configId
      })
      const needQueue = getKey('needQueue')
      this.$router.replace({ path: '/river/middle', query: { directionUrl: encodeURIComponent(this.diversionData.directionUrl), source: encodeURIComponent(this.source), ...this.diversionData, to: 'result', applyNo: this.applyNo, needQueue } })
    },
    ...mapActions(['getCaseListX', 'fetchDictionaryX']),
    changeHandler (event, type) {
      // 此时可以自行将文件上传至服务器
      const file = event.target.files[0]
      if (file) {
        this.$indicator()
        this.compressor(file).then(async (newFile) => {
          const base64File = await this.getImgBase64(newFile)
          const params = {
            base64Str: base64File,
            fileType: type
          }
          this.uploadOSS(params).then((response) => {
            this.$indicator.close()
            if (response.success) {
              if (type === 'CARD_FRONT_PHOTO') {
                this.frontImg = URL.createObjectURL(file)
                this.frontFile = response.data
                console.log(this.frontFile)
                this.frontCoverVisible = true
                this.ocrErrorVisible = false
              } else {
                this.backImg = URL.createObjectURL(file)
                this.backFile = response.data
                this.backCoverVisible = true
                this.ocrErrorVisible = false
              }
            } else {
              this.$message('上传身份证文件失败')
            }
          })
        })
      }
    },
    // 图片压缩
    compressor (file, quality = 0.8) {
      var _this = this
      return new Promise((resolve) => {
        return new ImageCompressor(file, {
          quality: quality,
          maxWidth: 1440,
          maxHeight: 1080,
          success (result) {
            if (result.size > 2 * 1000 * 1000) {
              _this.compressor(file, quality - 0.2)
            } else {
              resolve(result)
            }
          }
        })
      })
    },
    // 图片转化为base64
    getImgBase64 (file) {
      return new Promise((resolve) => {
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function (e) {
          let file = this.result.replace(/data:image\/\w*;base64,/, '')
          resolve(file)
        }
      })
    },
    // 置空
    empty () {
      this.form.name = null
      this.form.idcardNumber = null
      this.form.orderNo = null
      // this.infoVisible = false
      // this.errorInfoVisible = false
      // this.errorInfo = ''
      // this.ocrErrorVisible = false
      // this.ocrErrorInfo = ''
    },
    // OCR识别
    async IDOCR () {
      this.empty()
      this.$indicator('认证中')
      const params = {
        idcardFrontUrl: this.frontFile,
        idcardBackUrl: this.backFile
      }
      const response = await this.TXOCRX(params)
      this.$indicator.close()
      if (response.success) {
        if (!response.data.bizCode || response.data.bizCode === '000000') {
          // 只有身份信息识别成功才回显身份信息
          this.form.name = response.data.name
          this.form.idcardNumber = response.data.idcard
          this.form.orderNo = response.data.orderNo
          this.infoVisible = true
        } else {
          // 识别不成功
          this.$message(response.data.bizMsg)
          this.ocrErrorInfo = response.data.bizMsg
          this.ocrErrorVisible = true
          // this.$message('当前用户身份证有效期是否不足30天') // TODD小花项目
        }
      }
    },
    // 放弃激活额度
    giveUp (index) {
      this.$report({
        id: 10078,
        args: {
          target: index,
          position: 'page_auth_identity'
        }
      })
      if (this.pfrom === 'landing') {
        // this.navigateTo('/landing/index')
        this.$router.back()
      } else {
        this.detentionVisible = false
        this.$nextTick(() => {
          this.navigateTo('/')
        })
      }
    },

    // 用户挽留政策
    detention () {
      this.$report({
        id: 10076,
        position: 'page_auth_identity'
      })
      this.popupList = this.caseList
        .filter(
          (item) =>
            item.showType === 'POPUP' &&
            item.showAction === 'EXIT' &&
            item.step === 'OCR'
        )
        .sort((a, b) => b.sort - a.sort)
      this.detentionStep()
    },

    // 开始判断
    detentionStep () {
      if (this.popupList.length > 0) {
        this.currentActivity = this.popupList.shift()
        if (this.currentActivity.activeType !== 'PAY_IF_REFUSE_NEW') {
          if (this.currentActivity.activeType === 'PERSON_REPEAT_LOAN') {
            this.detentionVisible = true
          } else {
            this.activityTempleVisible = true
          }
        } else {
          this.activityVisible = true
        }
      } else {
        this.detentionVisible = true
      }
    },

    // 继续完成
    neverGiveup () {
      this.detentionVisible = false
      this.$report({
        id: 10078,
        args: {
          target: 0,
          position: 'page_auth_identity'
        }
      })
    },

    // 活动点击继续完成
    activityContinue () {
      this.$report({
        id: 10122,
        args: {
          position: 'page_auth_identity',
          target: 1,
          status: this.currentActivity.activeType
        }
      })
      if (this.currentActivity.activeType !== 'PAY_IF_REFUSE_NEW') {
        this.activityTempleVisible = false
      } else {
        this.activityVisible = false
      }
    },

    // 活动点击放弃
    activityGiveUp () {
      this.$report({
        id: 10122,
        args: {
          position: 'page_auth_identity',
          target: 2,
          status: this.currentActivity.activeType || undefined
        }
      })
      if (this.currentActivity.activeType !== 'PAY_IF_REFUSE_NEW') {
        this.activityTempleVisible = false
      } else {
        this.activityVisible = false
      }
      this.detentionStep()
    },

    navigateTo (path, replace) {
      if (replace) {
        this.$router.replace(path)
      } else {
        this.$router.push(path)
      }
    },
    nameInput () {
      debounce(() => {
        this.checkName(true)
      }, 500)
    },
    idcardInput () {
      debounce(() => {
        this.checkIDCard(true)
      }, 500)
    },
    addressInput () {
      debounce(() => {
        this.checkAddress(true)
      }, 500)
    },
    checkName (showError) {
      /**
       * 前端校验规则修改为只校验为空和长度
       * @author long.li
       * @date 2021年04月01日
       */
      if (!this.form.name) return false
      // if (/^[\u4e00-\u9fa5]{2,20}$/.test(this.form.name)) {
      if (this.form.name.length >= 2) {
        this.ocrErrorInfo = null
        this.ocrErrorVisible = false

        return true
      } else {
        if (showError) {
          this.ocrErrorInfo = '姓名格式错误，请重新输入'
          this.ocrErrorVisible = true
        }
        return false
      }
    },

    checkIDCard (showError) {
      /**
       * 前端校验规则修改为只校验为空和长度
       * @author long.li
       * @date 2021年04月01日
       */
      if (!this.form.idcardNumber) return false
      // if (this.form.idcardNumber.length === 18) {
      if (this.form.idcardNumber.length > 0) {
        this.ocrErrorInfo = null
        this.ocrErrorVisible = false

        return true
      } else {
        if (showError) {
          this.ocrErrorInfo = '身份证格式错误，请重新输入'
          this.ocrErrorVisible = true
        }
        return false
      }
    },

    checkAddress (showError) {
      const value = this.form.address
      if (!value) return false
      if (
        value.length > 5 &&
        /[\u4e00-\u9fa5][\u4e00-\u9fa5a-zA-Z0-9\-()（）·]+$/.test(value) &&
        !isEmojiCharacter(value)
      ) {
        this.errorInfo = null
        this.errorInfoVisible = false

        return true
      } else {
        if (showError) {
          this.errorInfo = '请输入正确的居住地址'
          this.errorInfoVisible = true
        }
        return false
      }
    },
    toResult () {
      if (this.process === 'NON') {
        this.$router.replace(`/authentication/result?applyNo=${this.applyNo}`)
      } else {
        this.toPreBase()
      }
    },
    toWait () {
      if (this.process === 'NON') {
        this.$router.replace(`/authentication/wait?applyNo=${this.applyNo}`)
      } else {
        this.toPreBase()
      }
    },
    toPreBase () {
      this.$router.replace(`/authentication/pre-base`)
    },
    nextApply () {
      if (getKey('needQueue')) {
        this.toWait()
      } else {
        this.toResult()
      }
    },
    async next () {
      const addressArr =
        this.form.addressSelect && this.form.addressSelect.split(/\s/)
      const addressObj = {}
      if (addressArr && addressArr.length) {
        Object.assign(addressObj, {
          province: addressArr[0],
          city: addressArr[1],
          area: addressArr[2],
          provinceCode: addressArr[3],
          cityCode: addressArr[4],
          areaCode: addressArr[5]
        })
      }
      const params = {
        loanPlatform: 'TMD',
        orderNo: this.form.orderNo,
        idCard: this.form.idcardNumber,
        name: this.form.name.replace(/\s+/g, ''),
        education: this.form.education,
        marital: this.form.marital,
        livingAddress: this.form.address,
        creditProcess: 'PRE_CREDIT_LIVING',
        ...addressObj
      }
      const res = await this.preCreditApplyX(params)
      
      if (res.success) {
        if (res.data.needQueue) {
          setKey('needQueue', res.data.needQueue)
        }

        // 用于预授信前是否要做活体,授信活体
        if (res.data.creditLiving === 'PRE_CREDIT_LIVING') {
          this.$router.replace('/authentication/face?step=PRE_CREDIT_LIVING')
          return
        }

        // 查询当前用户是否需要补充资料
        await this.fillProcess()
        // 预授信失败
        if (
          res.data &&
          res.data.preCheckResult === 'PRE_REFUSED' &&
          res.data.applyNo
        ) {
          this.applyNo = res.data.applyNo
          /**
           * 判断是否要展示产品推送广告
           */
          const { success, data } = await this.preCreditPopup()
          if (success) {
            if (!data) {
              return this.nextApply()
            } else {
              setKey('isRefused', this.applyNo)
              sessionStorage.setItem('refusedPr', JSON.stringify(data))
              this.diversionData = data
              this.showAd()
              return
            }
          }
        }


        // 认证完成后刷新用户信息
        this.getUserInfoX({ forceUpdate: true })
        this.$report({
          id: 10075,
          args: {
            succeed: 1,
            position: 'page_auth_identity'
          }
        })
        this.$statistics('OCR_SUC')
        this.navigateTo(`/authentication/base?pfrom=${this.pfrom || ''}`, true)
      } else {
        this.errorInfo = res.msg
        this.errorInfoVisible = true
        this.$report({
          id: 10075,
          args: {
            succeed: 0,
            message: this.errorInfo,
            position: 'page_auth_identity'
          }
        })
        this.$statistics('OCR_FAIL', {
          comment: res.msg
        })
      }
    },
    checkProtocols () {
      setKey('authenticationForm', this.form)
      setKey('frontImg', this.frontImg)
      setKey('backImg', this.backImg)
      this.$router.push({
        path: '/protocol/authorization',
        query: {
          busiType: 'CREDIT'
        }
      })
    }
  }
}
</script>

<style scoped lang="less" src="./styles/id.less"></style>
@import "../../assets/less/mixin.less";


<style lang="less" scoped>
@import "../../assets/less/mixin.less";

/deep/.new-person-activity {
  .default-content {
    padding-top: 0;
  }
}

@keyframes curtain {
  to {
    transform: translateY(0);
  }
}

@keyframes showAffect {
  to {
    opacity: 1;
  }
}

.drawer-container {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9999;
  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    opacity: 0;
  }
  .next-btn {
    opacity: 0;
    text-decoration: underline;
    color:#fff;
    position: relative;
    padding: 10px 30px;
    font-size: 24px;
    width: 200px;
    text-align: center;
    margin: 20px auto;
  }
  &.show {
     .drawer-content {
      animation: curtain 2s 0.1s forwards;
     }
     .mask {
      animation:  showAffect 0.3s  forwards;
     }
     .next-btn {
      animation:  showAffect 0.3s 2s forwards;
     }
  }
  .drawer-content {
    width: 750px;
    height: 690px;
    background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
    border-radius: 0px 0px 30px 30px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 110px;
    transform: translateY(-700px);
   
    h3 {
      width: 638px;
      height: 42px;
      background: url(./images/drawer/img_title.png) no-repeat;
      background-size: 100% 100%;
    }
   
    .detail {
      width: 750px;
      height: 409px;
      background: url(./images/drawer/img_card.png) no-repeat;
      background-size: 100% 100%;
      padding: 35px 75px;
      .title {
        display: flex;
        align-items: center;
        img {
          width:44px;
          height:44px;
          border-radius: 10px;
        }
        b {
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          padding:0 10px;
        }
        span {
          border-radius: 4px;
          border: 1px solid #D67D36;
          padding:6px 10px ;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #D67D36;
        }
      }

      .exp {
        margin-top: 40px;
        text-align: center;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #761212;
      }
      .quota {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: #761212;
        margin-top: -10px;
        small {
          font-size: 36px;
          padding-bottom: 10px;
        }
        span {
          font-size: 84px;
        }
      }
      .progress {
        width: 440px;
        height: 8px;
        background: #EFBA84;
        border-radius: 9px;
        margin: 0 auto;
        &:after {
          content: "";
          width: 406px;
          height: 8px;
          background: #FF6F29;
          border-radius: 9px;
          display: block;
        }
      }
      .max {
        margin: 0 auto;
        width: 540px;
        text-align: right;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #761212;
        padding-top: 10px;
      }
    }
    .button {
      width:580px;
      height:135px;
      background: url(./images/drawer/btn_tixian.png) no-repeat;
      background-size: 100% 100%;
      margin-top: -80px;
     
    }
    .count-down {
      display: flex;
      color: #fff;
      font-size: 20px;
      align-items: center;
      /deep/.van-count-down {
        padding-left: 5px;
        color: #fff;
        font-size: 20px !important;
      }
    }
    
  }
}
</style>
